import request from '@/util/request'


export const resourcesLeixingList = (data) => request.post('/api/resourcesLeixingList', data);  //文档类型列表

export const resourcesLeixingAdd = (data) => request.post('/api/resourcesLeixingAdd', data);  //文档类型添加

export const resourcesLeixingEdit = (data) => request.post('/api/resourcesLeixingEdit', data);  //文档类型编辑

export const resourcesLeixingDel = (data) => request.post('/api/resourcesLeixingDel', data);  //文档类型删除

export const resourcesLeixingDetail = (data) => request.post('/api/resourcesLeixingDetail', data);  //文档类型详情

export const departmentsLists = (data) => request.post('/api/departmentsLists', data);  //企业/部门树

export const departmentsEditUser = (data) => request.post('/api/departmentsEditUser', data);  //更新部门审核员